// Copyright (c) 2018 Deere & Company

import FactoryState, { getDefaultState } from '../state/factoryState';
import Factory from '../../../shared/models/factory';
// import Factory from '../../../shared/models/factory';
import actions from '../action-types';

const loadFactories = ( state, action ) => {

    const factories = action.factories.map( factory => new Factory( factory ) );
    return FactoryState.update( state, {
        factories: {
            $set: factories,
        },
    } );

};

const updateFactoryCode = ( state, action ) => FactoryState.update( state, {
    factoryCode: {
        $set: action.factoryCode,
    },
} );


export default ( state = getDefaultState(), action = {} ) => {

    const actionTypes = {
        [actions.LOAD_FACTORIES]: loadFactories,
        [actions.UPDATE_FACTORY_CODE]: updateFactoryCode,
    };
    const reducer = actionTypes[action.type];

    return reducer ? reducer( state, action ) : state;

};
